import { render, staticRenderFns } from "./courseLeadersList.vue?vue&type=template&id=a25f4164&scoped=true&lang=pug&"
import script from "./courseLeadersList.vue?vue&type=script&lang=js&"
export * from "./courseLeadersList.vue?vue&type=script&lang=js&"
import style0 from "./courseLeadersList.vue?vue&type=style&index=0&id=a25f4164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25f4164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VDivider,VSpacer})
